import { useEffect } from 'react';
import { navigateWorkspacePage } from '@/components/canvas/page/navigateWorkspacePage';

function isEditingInput(e: KeyboardEvent): boolean {
  const active = document.activeElement;
  return (
    active?.getAttribute('contenteditable') === 'true' ||
    active?.tagName === 'INPUT' ||
    active?.tagName === 'TEXTAREA' ||
    active?.tagName === 'SELECT'
  );
}

export interface UseWorkspacePageNavigationKeyboardOptions {
  /** 演示全屏时由 usePresentationKeyboard 接管方向键 */
  enabled: boolean;
}

export function useWorkspacePageNavigationKeyboard({
  enabled,
}: UseWorkspacePageNavigationKeyboardOptions) {
  useEffect(() => {
    if (!enabled) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (isEditingInput(e)) return;

      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        navigateWorkspacePage('prev');
        return;
      }
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        navigateWorkspacePage('next');
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [enabled]);
}
